function createUserManagement() {
    let userLogins = {
        users: []
    };
    let errorMessages = [];
    let emailInputField;
    let form;
    let userChooserElement;
    let clickHereElement;

    /**
     * @param userData {Object}
     */
    function updateLocalState(userData) {
        let stringed = JSON.stringify(userData);
        if (typeof stringed !== 'string')
            return;

        localStorage.setItem('biv-user-logins', stringed);
    }

    /**
     * @param emailString {string}
     * @returns {boolean}
     */
    function isEmailString(emailString) {
        if (typeof emailString === 'string') {
            let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            return emailRegex.test(emailString);
        }

        return false;
    }

    /**
     * @param item {HTMLElement}
     */
    function toggleSelectionStatus(item) {
        let selectedItems = document.querySelectorAll('.biv-user-select-item.selected');

        if (clickHereElement == null) {
            clickHereElement = document.querySelector('div.click-here-banner');
            if (clickHereElement == null)
                return;

        }

        if (selectedItems.length > 0) {
            selectedItems.forEach((element) => {
                element.classList.remove('selected');
            });

            let listItems = document.querySelectorAll('.biv-user-select-item');
            listItems.forEach((listItem) => {
                if (!listItem.classList.contains('selected')) {
                    listItem.classList.remove('not-selected');
                    clickHereElement.classList.add('closed');
                }
            });
            // emailInputField.type = 'email';
            emailInputField.parentElement.classList.remove('hidden');
        } else {
            item.classList.add('selected');

            let listItems = document.querySelectorAll('.biv-user-select-item');
            listItems.forEach((listItem) => {
                if (!listItem.classList.contains('selected')) {
                    listItem.classList.add('not-selected');
                }
            });
            // emailInputField.type = 'hidden';
            emailInputField.parentElement.classList.add('hidden');
            clickHereElement.classList.remove('closed');
        }
    }

    /**
     * @param userEmailString {string}
     * @returns HTMLElement
     */
    function createUserSelectElement(userEmailString) {
        let listElement = document.createElement('div');
        listElement.classList.add('biv-user-select-item');
        let userMailString = userEmailString;

        listElement.innerHTML = '<span class="biv-user-select-label">' + userEmailString + '</span>' +
            '<button class="delete-user"><i class="material-icons md-48">close</i></button>';

        let button = listElement.querySelector('button');
        button.onclick = (event) => {
            event.preventDefault();
            event.stopPropagation();

            listElement.remove();
            let ui = userLogins.users.indexOf(userMailString);

            userLogins.users.splice(ui, 1);
            updateLocalState(userLogins);
        }

        listElement.onclick = (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (emailInputField == null)
                return

            emailInputField.value = userMailString;
            toggleSelectionStatus(listElement);
        }

        return listElement;
    }

    function createClickHereBanner() {
        clickHereElement = document.createElement('div');
        clickHereElement.classList.add('click-here-banner');
        clickHereElement.innerHTML = 'Other Account';

        return clickHereElement;
    }

    function init() {
        document.querySelectorAll('input').forEach(input => {
            input.onfocus = () => {
                input.classList.add('touched');
                input.classList.remove('is-invalid');
            }
        })

        let userLoginData = localStorage.getItem('biv-user-logins');
        if (userLoginData)
            userLogins = JSON.parse(userLoginData);

        form = document.querySelector('form.biv-form');
        if (form == null)
            return;

        emailInputField = document.querySelector('input.biv-login-input-email#email');
        if (emailInputField == null)
            return;

        userChooserElement = document.querySelector('.biv-choose-user#biv-choose-user-list');
        if (userChooserElement != null) {
            userLogins.users.forEach((userMailString) => {
                userChooserElement.appendChild(createUserSelectElement(userMailString));
            });
            userChooserElement.prepend(createClickHereBanner());
        }

        errorMessages = document.querySelectorAll('.biv-error-message');
        if (errorMessages.length > 0 && userLogins.users.length > 0) {
            let recentUser = encodeURI(emailInputField.value);
            let userInList = userLogins.users.indexOf(recentUser);
            if (userInList > -1) {
                let ui = userLogins.users.indexOf(recentUser);
                userLogins.users.splice(ui, 1);
                updateLocalState(userLogins);
            }
        }

        form.addEventListener('submit', (event) => {
            let emailValue = encodeURI(emailInputField.value);

            let userInList = userLogins.users.indexOf(emailValue);
            if (userInList > -1)
                return;

            if (isEmailString(emailValue)) {
                userLogins.users.push(emailValue);
                updateLocalState(userLogins);
            }
        });

        if (clickHereElement == null) {
            clickHereElement = document.querySelector('div.click-here-banner');
            if (clickHereElement == null)
                return;

        } else {
            clickHereElement.classList.add('closed');
        }

        clickHereElement.onclick = function () {
            let selectedItems = document.querySelectorAll('.biv-user-select-item.selected');

            selectedItems.forEach((element) => {
                element.classList.remove('selected');
            });

            let listItems = document.querySelectorAll('.biv-user-select-item');
            listItems.forEach((listItem) => {
                if (!listItem.classList.contains('selected')) {
                    listItem.classList.remove('not-selected');
                }
            });
            clickHereElement.classList.add('closed');
            emailInputField.parentElement.classList.remove('hidden');
            emailInputField.value = '';
        }
    }

    init();
}

if (document) {
    document.addEventListener('DOMContentLoaded', (event) => {
        createUserManagement();
    });
}
